import { useWorkspaceImage } from "hooks/useWorkspace/useWorkspaceImage";
import { Skeleton } from "components/common/skeleton";
import { cn } from "utils/cn";
import { WorkspaceImageProps } from "./WorkspaceImage.types";

const sizeClasses = {
  md: {
    container: "h-8 w-8 rounded-md",
    image: "h-8 w-8",
    skeleton: "h-8 w-8",
    initial: "text-xs",
  },
  sm: {
    container: "h-6 w-6 rounded-md",
    image: "h-6 w-6",
    skeleton: "h-6 w-6",
    initial: "text-[10px]",
  },
} as const;

export const WorkspaceImage = ({
  workspaceId,
  workspaceName,
  imagePath,
  isActive,
  size = "md",
}: WorkspaceImageProps) => {
  const dimensions = sizeClasses[size];
  const {
    image: workspaceImage,
    hasImagePath: hasWorkspaceImagePath,
    shouldShowImage: shouldShowWorkspaceImage,
  } = useWorkspaceImage(workspaceId, imagePath);
  const initial = (workspaceName?.trim()?.[0] || "W").toUpperCase();

  return (
    <div
      className={cn(
        "flex items-center justify-center overflow-hidden bg-muted shadow-md",
        dimensions.container
      )}
    >
      {hasWorkspaceImagePath && workspaceImage.isLoading ? (
        <Skeleton className={dimensions.skeleton} />
      ) : shouldShowWorkspaceImage ? (
        <img
          src={workspaceImage.src}
          alt={workspaceName}
          className={cn("object-cover", dimensions.image)}
          decoding="async"
        />
      ) : (
        <span
          className={cn(
            "font-semibold",
            dimensions.initial,
            isActive ? "text-secondary" : "text-muted-foreground"
          )}
        >
          {initial}
        </span>
      )}
    </div>
  );
};
